import React from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";

const Table = ({ users, page, sort, setSort }) => {
  const { t } = useTranslation();

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="dark:bg-gray-700 text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th className="py-3 px-6" scope="col">
                {t("TITLE")}
              </th>
              <th scope="col" className="px-6 py-3 ">
                {t("MESSAGE")}
              </th>
              <th className="px-6 py-3 " scope="col">
                {t("SEND_TO")}
              </th>
              <th
                scope="col"
                onClick={() => {
                  if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
                className="py-3 cursor-pointer px-6 "
              >
                <div className="flex">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="h-4 w-4 " />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {users &&
              users.map((item, i) => {
                let sendToText = "";

                if (item?.sendToHR && item?.sendToACC) {
                  sendToText = `${startCase(item?.sendToACC)}, ${item?.sendToHR === "allHRs" ? "All HRs" : "Specific HR"}`;
                } else if (item?.sendToHR === "allHRs") {
                  sendToText = "All HRs";
                } else {
                  sendToText = item?.sendToACC || "";
                }

                return (
                  <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <th scope="row" className="py-3 px-6 border-r font-medium text-gray-900  dark:text-white">
                      {i + 1 + 10 * (page - 1)}
                    </th>
                    <td className="py-3 px-6 border-r text-gray-900">{item?.title}</td>
                    <td className="py-3 px-6 border-r text-gray-900">{item?.description}</td>
                    <td className="py-3 px-6 border-r text-gray-900">{sendToText}</td>
                    <td className="py-3 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}</td>
                  </tr>
                );
              })}
            {isEmpty(users) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={5}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
